module.exports = __webpack_public_path__ + "a94ce12bbbac460ae1a9e478fdd2c72b.MP3";